// extracted by mini-css-extract-plugin
export var divider = "_up-0";